import React from 'react';
import { motion } from 'framer-motion';

const PageLoader: React.FC = () => (
  <div
    style={{ background: '#111214' }}
    className="fixed inset-0 flex items-center justify-center z-50"
  >
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34.95 40.29"
      width="44"
      height="44"
      animate={{ rotate: 360 }}
      transition={{ duration: 2.4, repeat: Infinity, ease: 'linear' }}
    >
      <defs>
        <linearGradient id="pl-grad" x1="0" y1="20.15" x2="34.95" y2="20.15" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2f69fa" />
          <stop offset=".36" stopColor="#6d49e7" />
          <stop offset=".42" stopColor="#7b4adb" />
          <stop offset=".52" stopColor="#a04ebd" />
          <stop offset=".66" stopColor="#db538c" />
          <stop offset=".71" stopColor="#f1567b" />
          <stop offset="1" stopColor="#fe813b" />
        </linearGradient>
      </defs>
      <path
        fill="url(#pl-grad)"
        d="M32.35,15.75L6.02.54C3.34-1,0,.93,0,4.02v31.97c0,3.31,3.58,5.38,6.45,3.72l25.9-14.95c3.47-2,3.47-7,0-9Z"
      />
    </motion.svg>
  </div>
);

export default PageLoader;
